import { config } from '../config';

/**
 * Utilidades para manejo seguro de evidencias de seguridad
 * Sistema separado de las evidencias de tickets
 */

/**
 * Crea una URL de objeto para previsualización segura de evidencias de seguridad
 * @param {string} evidenceUrl - URL de la evidencia de seguridad
 * @returns {Promise<string>} - URL del objeto para previsualización
 */
export async function createEvidenciaSeguridadObjectUrl(evidenceUrl) {
    try {
        const token = (localStorage.getItem('token') || sessionStorage.getItem('token'));
        if (!token) {
            throw new Error('No se encontró token de autenticación');
        }

        // Determinar la URL completa basándonos en si evidenceUrl ya incluye /api
        let fullUrl;
        if (evidenceUrl.startsWith('/api') || evidenceUrl.startsWith('api')) {
            // Si ya tiene /api, usamos la base sin /api
            const baseUrlWithoutApi = config.api.baseURL.replace(/\/api\/?$/, '');
            const path = evidenceUrl.startsWith('/') ? evidenceUrl : `/${evidenceUrl}`;
            fullUrl = `${baseUrlWithoutApi}${path}`;
        } else {
            // Si no tiene /api, usamos la baseURL completa (que incluye /api)
            const apiBase = config.api.baseURL.endsWith('/') ? config.api.baseURL.slice(0, -1) : config.api.baseURL;
            const path = evidenceUrl.startsWith('/') ? evidenceUrl : `/${evidenceUrl}`;
            fullUrl = `${apiBase}${path}`;
        }

        const response = await fetch(fullUrl, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error al cargar evidencia de seguridad: ${response.status}`);
        }

        const blob = await response.blob();
        return URL.createObjectURL(blob);
    } catch (error) {
        console.error('Error al crear URL de objeto para evidencia de seguridad:', error);
        throw error;
    }
}

/**
 * Descarga una evidencia de seguridad a través de la API
 * @param {string} evidenceUrl - URL de la evidencia de seguridad
 * @param {string} fileName - Nombre del archivo para descargar
 */
export async function downloadEvidenciaSeguridadViaAPI(evidenceUrl, fileName = 'evidencia-seguridad') {
    try {
        const token = (localStorage.getItem('token') || sessionStorage.getItem('token'));
        if (!token) {
            alert('No se encontró token de autenticación');
            return;
        }

        // Determinar la URL completa basándonos en si evidenceUrl ya incluye /api
        let fullUrl;
        if (evidenceUrl.startsWith('/api') || evidenceUrl.startsWith('api')) {
            const baseUrlWithoutApi = config.api.baseURL.replace(/\/api\/?$/, '');
            const path = evidenceUrl.startsWith('/') ? evidenceUrl : `/${evidenceUrl}`;
            fullUrl = `${baseUrlWithoutApi}${path}`;
        } else {
            const apiBase = config.api.baseURL.endsWith('/') ? config.api.baseURL.slice(0, -1) : config.api.baseURL;
            const path = evidenceUrl.startsWith('/') ? evidenceUrl : `/${evidenceUrl}`;
            fullUrl = `${apiBase}${path}`;
        }

        const response = await fetch(fullUrl, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error al descargar evidencia de seguridad: ${response.status}`);
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        // Crear enlace de descarga
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Limpiar URL del objeto
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error al descargar evidencia de seguridad:', error);
        alert('Error al descargar la evidencia de seguridad');
    }
}
